import React, { useState } from 'react';
import { Box, Typography, Tooltip, ClickAwayListener, IconButton, useMediaQuery } from '@mui/material';
import { getText } from '../libs/utils';
import { RoundedQuestion, CloseIcon } from '../assets/images/icons';
import { styled, useTheme} from "@mui/material/styles";

const MyBox = styled(Box)(() => ({
  cursor: 'pointer',
  "&.active": {
    color: '#686868',
    "svg path": {
      fill: '#A9A9A9'
    }
  }
}))

const NetworkLoad = ({order}) => {
  const theme = useTheme();
  let isXSnSM = useMediaQuery(theme.breakpoints.down('md'));
  let isXS = useMediaQuery(theme.breakpoints.only('xs'));
  const [opened, setOpened] = useState(false);

  let loadText = '';
  const networkInfo = order.fromNetworkInfo;
  if (networkInfo) {
    if (networkInfo.load < 15) {
      loadText = getText("networkLoadLow")
    } else if (networkInfo.load < 65) {
      loadText = getText("networkLoadAvarage")
    } else {
      loadText = getText("networkLoadHigh")
    }
  }

  return (
    // <Box sx={{ paddingLeft: {xs: 0, sm: '17px'} }}>
    <Box>
      <Box sx={{ fontWeight: 600, fontSize: 14 }}>
        <ClickAwayListener onClickAway={() => setOpened(false)}>
          <div>
            <Tooltip
              open={opened}
              onClose={() => setOpened(false)}
              PopperProps={{
                disablePortal: true,
              }}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title={
                <Box sx={{position: 'relative'}}>
                  <CloseIcon
                    aria-label="close"
                    onClick={() => setOpened(false)}
                    style={{
                      position: "absolute",
                      right: '-14px',
                      top: '-14px',
                      cursor: 'pointer'
                    }}
                  />
                  <Typography variant='boldRegCaption' component="div" sx={{ marginBottom: '7px' }}>{getText('netloadHelpLoadHead')}</Typography>
                  <Typography variant='caption'>{getText('netloadHelpLoadText')}</Typography>
                </Box>
              }
              placement={isXSnSM ? 'top-end': 'right-end'}
            >
              <MyBox
                className={opened ? 'active' : ''}
                onClick={() => setOpened(!opened)}
              >
                {loadText}<RoundedQuestion style={{ position: 'relative', top: 3, left: 5, marginRight: '7px' }} />
              </MyBox>
            </Tooltip>
          </div>
        </ClickAwayListener>
      </Box>
      <Box sx={{ color: 'primary.grey', fontSize: 12 }}>{getText('networkLoadState')}</Box>
    </Box>
  )
}

export default NetworkLoad